import { PlusIcon, XIcon, TrashSimpleIcon, SortAscending, SortDescending } from '@phosphor-icons/react';
import 'styles/global/components.global.css';

const PocketwatchAssets = () => {
    return (
        <div style={{ padding: '2rem', maxWidth: '1200px', margin: '0 auto' }}>
            <h1>Pocketwatch Design System</h1>
            <p style={{ marginBottom: '3rem', color: '#666' }}>Component reference and style guide</p>

            <div className="grid col-2 large-gap">
              <div className="card r1-1" style={{ backgroundColor: 'var(--d1)' }}></div>
              <div className="card r1-1" style={{ backgroundColor: 'var(--d2)' }}></div>
              <div className="card r1-1" style={{ backgroundColor: 'var(--d3)' }}></div>
              <div className="card r1-1" style={{ backgroundColor: 'var(--d4)' }}></div>
            </div>


            {/* Typography */}
            <section style={{ marginBottom: '3rem' }}>
                <h2 style={{ borderBottom: '2px solid #333', paddingBottom: '0.5rem', marginBottom: '1rem' }}>Typography</h2>
                <div style={{ display: 'flex', gap: '4rem' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                              <div>
                        <code>.xxlarge</code>
                        <p className="xxlarge">Extra Extra Large Text </p>
                    </div>
                    <div>
                        <code>.xlarge</code>
                        <p className="xlarge">Extra Large Text </p>
                    </div>
                    <div>
                        <code>.large</code>
                        <p className="large">Large Text - Section Headers</p>
                    </div>
                    <div>
                        <code>.medium</code>
                        <p className="medium">Medium Text - Subheadings</p>
                    </div>
                    <div>
                        <code>.regular</code>
                        <p className="regular">Regular Text - Body content and labels</p>
                    </div>
                    <div>
                        <code>.small</code>
                        <p className="small">Small Text - Secondary information</p>
                    </div>
            
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                                   <div>
                        <code>.number xxlarge</code>
                        <p className="number xxlarge">£1,234,567.90</p>
                    </div>
                    <div>
                        <code>.number xlarge</code>
                        <p className="number xlarge">£1,234,567.90</p>
                    </div>
                    <div>
                            <code>.number large</code>
                            <p className="number large">£1,234,567.90</p>
                        </div>
                    <div>
                            <code>.number medium</code>
                            <p className="number medium">£1,234,567.90</p>
                        </div>
                        <div>
                            <code>.number regular</code>
                            <p className="number regular">£1,234,567.90</p>
                        </div>  <div>
                            <code>.number small</code>
                            <p className="number small">£1,234,567.90</p>
                        </div>
                    
                 
                </div>
                </div>
            </section>

            {/* Buttons */}
            <section style={{ marginBottom: '3rem' }}>
                <h2 style={{ borderBottom: '2px solid #333', paddingBottom: '0.5rem', marginBottom: '1rem' }}>Buttons</h2>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                    <div>
                        <h3>Button Sizes</h3>
                        <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', marginTop: '0.5rem' }}>
                            <button className="button large">Large Button</button>
                            <button className="button medium">Medium Button</button>
                            <button className="button small">Small Button</button>
                        </div>
                    </div>
                    <div>
                        <h3>Button States</h3>
                        <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', marginTop: '0.5rem' }}>
                            <button className="button large">Normal</button>
                            <button className="button large" disabled>Disabled</button>
                        </div>
                    </div>
                    <div>
                        <h3>Icon Buttons</h3>
                        <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', marginTop: '0.5rem' }}>
                            <button className="button medium icon"><PlusIcon size={20} /></button>
                            <button className="button medium icon"><XIcon size={20} /></button>
                            <button className="button medium icon"><TrashSimpleIcon size={20} /></button>
                            <button className="button medium icon"><SortAscending size={20} /></button>
                            <button className="button medium icon"><SortDescending size={20} /></button>
                        </div>
                    </div>
                    <div>
                        <h3>Button Group</h3>
                        <div className="button-group" role="group" style={{ marginTop: '0.5rem' }}>
                            <input type="radio" className='button-item' name="example" id="option1" defaultChecked />
                            <label htmlFor="option1">Option 1</label>
                            <input type="radio" className='button-item' name="example" id="option2" />
                            <label htmlFor="option2">Option 2</label>
                            <input type="radio" className='button-item' name="example" id="option3" />
                            <label htmlFor="option3">Option 3</label>
                        </div>
                    </div>
                </div>
            </section>

            {/* Form Elements */}
            <section style={{ marginBottom: '3rem' }}>
                <h2 style={{ borderBottom: '2px solid #333', paddingBottom: '0.5rem', marginBottom: '1rem' }}>Form Elements</h2>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                    <div>
                        <h3>Form Group</h3>
                        <div className='form-group' style={{ marginTop: '0.5rem' }}>
                            <div className='form-item'>
                                <label>Label 1</label>
                                <input type="text" className="large" placeholder="Large input" />
                            </div>
                            <div className='form-item'>
                                <label>Label 2</label>
                                <input type="text" className="large" placeholder="Another input" />
                            </div>
                        </div>
                    </div>
                    <div>
                        <h3>Input Sizes</h3>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', marginTop: '0.5rem' }}>
                            <input type="text" className="large" placeholder="Large input" />
                            <input type="text" className="medium" placeholder="Medium input" />
                            <input type="text" placeholder="Default input" />
                        </div>
                    </div>
                    <div>
                        <h3>Number Inputs</h3>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', marginTop: '0.5rem' }}>
                            <input type="text" className="number large" placeholder="Large number" />
                            <input type="text" className="number medium" placeholder="Medium number" />
                        </div>
                    </div>
                </div>
            </section>

            {/* Layout Utilities */}
            <section style={{ marginBottom: '3rem' }}>
                <h2 style={{ borderBottom: '2px solid #333', paddingBottom: '0.5rem', marginBottom: '1rem' }}>Layout Utilities</h2>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                    <div>
                        <h3>Flex Row</h3>
                        <div className="flex row gap--normal" style={{ padding: '1rem', background: '#f0f0f0' }}>
                            <div style={{ padding: '0.5rem', background: '#fff' }}>Item 1</div>
                            <div style={{ padding: '0.5rem', background: '#fff' }}>Item 2</div>
                            <div style={{ padding: '0.5rem', background: '#fff' }}>Item 3</div>
                        </div>
                    </div>
                    <div>
                        <h3>Flex Row - Space Between</h3>
                        <div className="flex row space" style={{ padding: '1rem', background: '#f0f0f0' }}>
                            <div style={{ padding: '0.5rem', background: '#fff' }}>Left</div>
                            <div style={{ padding: '0.5rem', background: '#fff' }}>Right</div>
                        </div>
                    </div>
                    <div>
                        <h3>Flex Column</h3>
                        <div className="flex col gap--normal" style={{ padding: '1rem', background: '#f0f0f0' }}>
                            <div style={{ padding: '0.5rem', background: '#fff' }}>Item 1</div>
                            <div style={{ padding: '0.5rem', background: '#fff' }}>Item 2</div>
                            <div style={{ padding: '0.5rem', background: '#fff' }}>Item 3</div>
                        </div>
                    </div>
                    <div>
                        <h3>Grid 2 Column</h3>
                        <div className="grid col-2 gap--normal" style={{ padding: '1rem', background: '#f0f0f0' }}>
                            <div style={{ padding: '0.5rem', background: '#fff' }}>Item 1</div>
                            <div style={{ padding: '0.5rem', background: '#fff' }}>Item 2</div>
                            <div style={{ padding: '0.5rem', background: '#fff' }}>Item 3</div>
                            <div style={{ padding: '0.5rem', background: '#fff' }}>Item 4</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Spacing */}
            <section style={{ marginBottom: '3rem' }}>
                <h2 style={{ borderBottom: '2px solid #333', paddingBottom: '0.5rem', marginBottom: '1rem' }}>Spacing</h2>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    <div>
                        <h3>Gaps</h3>
                        <code>.small-gap</code>, <code>.gap--normal</code>, <code>.medium-gap</code>, <code>.large-gap</code>, <code>.xlarge-gap</code>
                    </div>
                    <div>
                        <h3>Margins</h3>
                        <code>.margin-top--small</code>, <code>.margin-top--medium</code>, <code>.margin-top--large</code>
                    </div>
                </div>
            </section>

            {/* Alignment */}
            <section style={{ marginBottom: '3rem' }}>
                <h2 style={{ borderBottom: '2px solid #333', paddingBottom: '0.5rem', marginBottom: '1rem' }}>Alignment</h2>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    <div>
                        <code>.center</code> - Align items center
                    </div>
                    <div>
                        <code>.center-center</code> - Center both axes
                    </div>
                </div>
            </section>

            {/* Cards */}
            <section style={{ marginBottom: '3rem' }}>
                <h2 style={{ borderBottom: '2px solid #333', paddingBottom: '0.5rem', marginBottom: '1rem' }}>Cards</h2>
                <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
                    <div className="card" style={{ width: '200px', height: '150px' }}>
                        <p className="large">Basic Card</p>
                        <p>Card content goes here</p>
                    </div>
                    <div className="card r1-1" style={{ width: '200px' }}>
                        <p className="large">1:1 Ratio Card</p>
                    </div>
                    <div className="card r4-3" style={{ width: '200px' }}>
                        <p className="large">4:3 Ratio Card</p>
                    </div>
                </div>
            </section>

            {/* Icons */}
            <section style={{ marginBottom: '3rem' }}>
                <h2 style={{ borderBottom: '2px solid #333', paddingBottom: '0.5rem', marginBottom: '1rem' }}>Icons</h2>
                <div style={{ display: 'flex', gap: '2rem', flexWrap: 'wrap' }}>
                    <div>
                        <div className="icon--small"><PlusIcon size={16} /></div>
                        <code>.icon--small</code>
                    </div>
                    <div>
                        <div className="icon--medium"><PlusIcon size={20} /></div>
                        <code>.icon--medium</code>
                    </div>
                    <div>
                        <div className="icon--large"><PlusIcon size={24} /></div>
                        <code>.icon--large</code>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default PocketwatchAssets;
